import { PermissionsSource } from '@core/types/permissions.source'

export const navigationClient = [
  {
    title: 'NAV_CLIENT.MAP',
    icon: 'map',
    permission: PermissionsSource.MAP,
    url: '/client/map',
  },
  {
    title: 'NAV_CLIENT.FLEET',
    icon: 'directions_car',
    permission: PermissionsSource.FLEET,
    url: '/client/fleet',
  },
  {
    title: 'NAV_CLIENT.FUEL',
    icon: 'local_gas_station',
    permission: PermissionsSource.FUEL,
    url: '/client/fuel',
  },
  {
    title: 'NAV_CLIENT.DRIVERS',
    icon: 'person',
    permission: PermissionsSource.DRIVERS,
    url: '/client/drivers',
  },
  {
    title: 'NAV_CLIENT.DRIVING_BEHAVIOUR',
    icon: 'score',
    permission: PermissionsSource.DRIVING_BEHAVIOUR,
    url: '/client/driving-behaviour',
  },
  {
    title: 'NAV_CLIENT.ASSETS',
    icon: 'business_center',
    permission: PermissionsSource.ASSET,
    url: '/client/assets',
  },
  {
    title: 'NAV_CLIENT.CAMERAS',
    icon: 'linxiovision_icon',
    permission: PermissionsSource.CAMERAS,
    url: '/client/cameras-events',
  },
  {
    title: 'NAV_CLIENT.CAMERAS_ARCHIVE',
    // not 'videocam' — that asset is byte-identical to the Cameras item's 'linxiovision_icon',
    // so the two adjacent rail items would be indistinguishable
    icon: 'history_toggle',
    // same gate as the Cameras item — the backend issues only the bare `cameras` permission
    permission: PermissionsSource.CAMERAS,
    url: '/client/cameras-archive',
  },
  {
    title: 'NAV.ALERTS',
    icon: 'warning',
    permission: PermissionsSource.ALERTS,
    url: '/client/alerts',
  },
  {
    title: 'NAV_CLIENT.REPORTS',
    icon: 'insert_drive_file',
    permission: PermissionsSource.REPORTS,
    url: '/client/reports',
  },
  {
    title: 'NAV_CLIENT.MESSENGER',
    icon: 'chat',
    permission: PermissionsSource.MESSENGER,
    url: '/client/messenger',
  },
  {
    title: 'NAV_CLIENT.DEVICES',
    icon: 'devices_other',
    permission: PermissionsSource.DEVICE,
    url: '/client/devices',
  },
  {
    title: 'NAV_CLIENT.BILLING',
    icon: 'request_quote',
    permission: PermissionsSource.BILLING,
    url: '/client/billing',
  },
  {
    title: 'NAV_CLIENT.CONFIGURATION',
    icon: 'settings',
    permission: PermissionsSource.CONFIGURATION,
    url: '/client/configuration',
  },
]
